import api from './api';

/**
 * Subscription service
 */
export const subscriptionService = {
  getPage: async (month = null) => {
    const params = month ? `?month=${month}` : '';
    const response = await api.get(`/subscriptions/page${params}`);
    return response.data;
  },

  getSubscriptions: async (isActive = null, options = {}) => {
    const searchParams = new URLSearchParams();
    if (isActive !== null) searchParams.set('isActive', String(isActive));
    if (options.skipAdvance) searchParams.set('skipAdvance', 'true');
    const qs = searchParams.toString();
    const response = await api.get(`/subscriptions${qs ? `?${qs}` : ''}`);
    return response.data;
  },

  getSubscription: async (id) => {
    const response = await api.get(`/subscriptions/${id}`);
    return response.data;
  },

  getSummary: async (month = null, options = {}) => {
    const searchParams = new URLSearchParams();
    if (month) searchParams.set('month', month);
    if (options.skipAdvance) searchParams.set('skipAdvance', 'true');
    const qs = searchParams.toString();
    const response = await api.get(`/subscriptions/summary${qs ? `?${qs}` : ''}`);
    return response.data;
  },

  getPayments: async (id) => {
    const response = await api.get(`/subscriptions/${id}/payments`);
    return response.data;
  },

  createSubscription: async (subscriptionData) => {
    const response = await api.post('/subscriptions', subscriptionData);
    return response.data;
  },

  updateSubscription: async (id, subscriptionData) => {
    const response = await api.put(`/subscriptions/${id}`, subscriptionData);
    return response.data;
  },

  deleteSubscription: async (id) => {
    const response = await api.delete(`/subscriptions/${id}`);
    return response.data;
  },

  getAlerts: async (days = 7) => {
    const response = await api.get(`/subscriptions/alerts?days=${days}`);
    return response.data;
  },

  markAsPaid: async (id) => {
    const response = await api.post(`/subscriptions/${id}/mark-paid`);
    return response.data;
  }
};
